<template>
<v-card>
  <v-dialog width="600" v-model="dialogSchemaName">
    <EditName  v-on:updated="(schemaToEdit.name = $event) && (dialogSchemaName = false)" :schema="schemaToEdit"></EditName>
  </v-dialog>
  <TestInfo v-if="SettingsApp.displayTestInfo() && acl.isWorker()"/>
  <v-card-title>
    <v-spacer></v-spacer>
    <v-text-field v-model="search" append-icon="search" :label="`${$t('data-table.search')}`" single-line hide-details></v-text-field>
  </v-card-title>
  <v-data-table :headers="headers" :items="schemas" class="elevation-1" :loading="loading" :search="search" :rows-per-page-text="tableTranslations.rowsPerPageText" :no-data-text="tableTranslations.noDataText"
    :no-results-text="tableTranslations.noResultsText" :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination">
    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <td class="text-xs-right">{{ props.item.id }}</td>
      <td style="cursor:pointer" @dblclick="updateSchemaName(props.item)" class="text-xs-left">{{ props.item.name }}
        <v-icon v-if="props.item.confirmation > 0" class="light-green--text">check_circle_outline</v-icon>
      </td>
      <td class="text-xs-right">
        <v-layout align-center row fill-height>
          <v-switch class="schema-list-switch" color="teal lighten-2" :disabled="loading" :input-value="(props.item.status == 1) ? true : false" @change="toggleActive($event, props.item)"></v-switch>
        </v-layout>
      </td>
      <td class="text-xs-right">
        <team-picker :schema_id="props.item.id" :teamIds="props.item.teams" @updateTeams="props.item.teams = $event"></team-picker>
      </td>
      <td class="text-xs-right">
        <v-btn :disabled="TestHelper.testAttemptsExceeded(props.item)" color="teal darken-2" small round :to="{ name: 'form-fill', params: { schemaId: props.item.id } }">
          <v-icon class="schema-edit-icon">add</v-icon>
        </v-btn>
      </td>
      <td class="text-xs-right">
        <v-layout align-center row fill-height>
          <v-flex xs3>
            <v-btn round small block dark color="teal darken-2" :to="{ name: 'form-view', params: { schemaId: props.item.id } }">
              <span style="margin-right: 10px; font-weight: bold">{{ props.item.forms_amount }}</span>
              <v-icon dark>description</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </td>
      <td class="text-xs-right">
        <v-btn color="teal darken-3" :to="{ name: 'schema-templates', params: { schemaId: props.item.id } }" round small dark slot="activator">
          <span style="margin-right: 10px; font-weight: bold">{{ props.item.templates_amount }}</span>
          <v-icon dark>wallpaper</v-icon>
        </v-btn>
      </td>
      <td class="text-xs-right">
        <v-btn color="teal darken-4" fab small dark :to="{ name: 'schema-update', params: { schemaId: props.item.id } }">
          <v-icon class="schema-edit-icon" dark>edit</v-icon>
        </v-btn>
      </td>
      <td class="text-xs-right">
        <Settings :schema="props.item" />
      </td>
      <td class="text-xs-right">
        <v-btn color="deep-orange darken-3" fab small dark @click="deleteSchema(props.item)">
          <v-icon dark>delete_forever</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</v-card>
</template>

<script>
import i18n from '@/plugins/vuei18n'
import http from '@/plugins/http'
import TeamPicker from './list/TeamPicker'
import ExportMenu from './list/ExportMenu'
import Settings from './Settings'
import SettingsApp from '@/plugins/Settings'
import TestInfo from '@/components/form/TestInfo'
import Acl from "@/plugins/Acl";
import TestHelper from "@/plugins/TestHelper";
import EditName from "@/components/schema/EditName";


export default {
  components: {
    EditName,
    TeamPicker,
    ExportMenu,
    Settings,
    TestInfo
  },
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    headers: () => [{
        text: i18n.t('base.id'),
        value: "id",
        align: "right",
        width: "100px"
      },
      {
        text: i18n.t('schema.list.name'),
        value: "name",
        width: "400px"
      },
      {
        text: i18n.t('schema.builder.basic.active'),
        sortable: false,
        align: 'center',
        width: '60px'
      },
      {
        text: i18n.t('schema.list.teams'),
        value: "teams",
        sortable: false,
        align: 'center',
        width: '100px'
      },
      {
        text: i18n.t('archive.filter.new'),
        sortable: false,
        align: 'center',
        width: '100px'
      },
      {
        text: i18n.t('schema.list.forms'),
        sortable: false,
        align: 'center',
        width: '100px'
      },
      {
        text: i18n.t('schema.list.templates'),
        sortable: false,
        align: 'center',
        width: '120px'
      },
      {
        text: i18n.t('schema.list.update'),
        sortable: false,
        align: 'center',
        width: '60px'
      },
      {
        text: i18n.t('schema.list.settings'),
        sortable: false,
        align: 'center',
        width: '60px'
      },
      {
        text: i18n.t('schema.list.delete.delete'),
        sortable: false,
        align: 'center',
        width: '60px'
      }
    ],
  },
  data() {
    return {
      pagination: this.$store.getters.pagination,
      schemas: [],
      loading: false,
      schemaToEdit : null,
      search: "",
      dialogSchemaName : false,
      SettingsApp,
      acl: new Acl(),
      TestHelper
    }
  },
  methods: {
    updateSchemaName(schema){
      this.schemaToEdit = schema
      this.dialogSchemaName = true
    },
    deleteSchema(schema) {
      this.$confirm(this.$t('schema.list.delete.confirmation', {
          "schema-name": schema.name
        }))
        .then(res => {
          if (res) {
            this.loading = true
            this.$store.dispatch('deleteSchema', schema.id)
              .then(() => {
                this.$store.commit('setSnack', {
                  message: this.$t('schema.list.delete.success-message', {
                    'schema-name': schema.name
                  }),
                  color: 'success'
                })
                this.loadSchemas()
              })
              .catch(() => {
                this.$store.commit('setSnack', {
                  message: this.$t('schema.list.delete.error-message', {
                    'schema-name': schema.name
                  }),
                  color: 'danger'
                })
                this.loading = false;
              })
          }
        })
    },
    loadSchemas() {
      this.loading = true
      http.get('schemas')
        .then(response => {
          this.schemas = response.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    toggleActive(isActive, schema) {
      this.loading = true
      this.$store.dispatch('setSchemaStatus', {
          status: isActive ? 1 : 0,
          id: schema.id
        })
        .then(() => {
          this.loading = false
          this.$store.commit('setSnack', {
            message: isActive ? this.$t('schema.list.status-messages.activated', {
              'schema-name': schema.name
            }) : this.$t('schema.list.status-messages.deactivated', {
              'schema-name': schema.name
            }),
            color: 'success'
          })
        }).catch(() => {
          this.loading = false
          this.$store.commit('setSnack', {
            message: this.$t('schema.list.status-messages.fail', {
              'schema-name': schema.name
            }),
            color: 'danger'
          })
        })
    }
  },
  created() {
    this.loadSchemas()
  }
}
</script>

<style scoped>
.schema-list-switch {
  margin: 10px 0 -10px;
}
</style>
